import { Classes, Dialog, TextArea } from "@blueprintjs/core";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { useState } from "react";
import styles from "./BlockAccessDialog.module.scss";

interface BlockAccessDialogProps {
    /** Кому отключаем: «Петров Пётр Петрович (petrov)» */
    who: string;
    onConfirm: (reason: string) => Promise<unknown>;
    onClose: () => void;
}

/**
 * Подтверждение отключения доступа к приложению. Причина необязательна.
 * Включение подтверждения не требует - его делают одной кнопкой.
 */
export const BlockAccessDialog = ({ who, onConfirm, onClose }: BlockAccessDialogProps) => {
    const [reason, setReason] = useState("");
    const [busy, setBusy] = useState(false);

    const confirm = async () => {
        setBusy(true);
        await onConfirm(reason.trim());
        setBusy(false);
        onClose();
    };

    return (
        <Dialog
            isOpen={true}
            title="Отключить доступ"
            isCloseButtonShown={true}
            onClose={onClose}
            backdropClassName="standard"
            canOutsideClickClose={!busy}
            className={`figma-dialog ${styles.dialog}`}
        >
            <div className={Classes.DIALOG_BODY}>
                <div className={styles.text}>
                    <b>{who}</b> сразу выйдет из приложения на всех устройствах и не сможет войти, пока доступ не
                    включат.
                </div>
                <div className={styles.label}>Причина (необязательно)</div>
                <div className={`${Classes.INPUT_GROUP} planr-default-input`}>
                    <TextArea
                        value={reason}
                        autoFocus={true}
                        rows={3}
                        className={Classes.FILL}
                        onChange={(e) => setReason(e.currentTarget.value)}
                    />
                </div>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <PlanrButton type="graybtn" size="small" onClick={onClose} disabled={busy}>
                        Отмена
                    </PlanrButton>
                    <PlanrButton type="danger" size="small" onClick={confirm} disabled={busy}>
                        Отключить доступ
                    </PlanrButton>
                </div>
            </div>
        </Dialog>
    );
};
